import classNames from 'classnames';
import { LockFill, PersonFill } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import { ThemeButton } from "./Themebutton";
import { AuthContextState } from "./AuthWrapper";
import { Student } from '../api/client';

declare interface NavbarProps {
  loggedIn: boolean;
  login: () => void;
  logout: () => void;
  state: AuthContextState;
  student: Student | undefined;
}

export function Navbar({ loggedIn, login, logout, state, student }: NavbarProps): JSX.Element {
  const iconClasses = classNames('h-5 w-5 mb-1 mr-1 inline text-usfApple');
  const linkToProfile: string = student ? `profile/${student.id}` : "/onboard";
  return (
    <nav className="flex sm:flex-row flex-col fixed sm:justify-between justify-center items-center sm:h-16 h-24 bg-[#384B52] text-White relative shadow-sm font-mono" role="navigation">
      <div className='pl-0 md:pl-8 sm:mb-0 mb-2'>
        <Link to="/Index" className="text-white text-sm lg:text-lg">Office of National Scholars Portal</Link>
        <span className="text-usfSlate mx-2">|</span>
        <Link to="https://www.usf.edu/ons/" className="text-white text-sm lg:text-lg">Learn More</Link>
      </div>
      <div className="pr-0 md:pr-8 flex flex-wrap justify-center">
        <ThemeButton />
        <span className="text-usfSlate mx-2">|</span>
        <Link to={linkToProfile} className=" text-white text-sm lg:text-lg">My Student Profile</Link>
        <span className="text-usfSlate mx-2">|</span>
        {state.user?.admin && <Link to="/admin/dashboard" className="text-white text-sm lg:text-lg">Admin</Link>}
        {state.user?.admin && <span className="text-usfSlate mx-2">|</span>}

        {!loggedIn && (
          <Link to="#" onClick={login} className="text-white animate-pulseFive text-sm  lg:text-lg">
            <PersonFill className={iconClasses} />
            <span>Sign in</span>
          </Link>
        )}

        {loggedIn && (
          <Link to="#" onClick={logout} className="text-white text-sm lg:text-lg">
            <LockFill className={iconClasses} />
            <span>Sign out</span>
          </Link>
        )}
      </div>
    </nav>
  )
}
